import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PushCreateTemplate } from 'components/Templates'

const PushEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const id = /^\/admin\/push_notification\/[a-zA-Z0-9]+$/.test(pathname)
    ? pathname.split('/admin/push_notification/')[1]
    : undefined

  return (
    <Layout headline={'運営からのお知らせ'} title={'プッシュ通知設定'}>
      <PushCreateTemplate id={id} />
    </Layout>
  )
}

export default PushEdit
